export default __webpack_public_path__ + "static/media/bg-lk.b00d3422.webp";